<template>
  <v-content>
    <v-layout row wrap>
      <v-flex xs12 :class="this.$vuetify.breakpoint.lgAndUp? 'pa-5':'pa-3'">
        <h1 class="content-title">Page Not Found</h1>

        <p>Page you are looking is not available. Please use our menu to explore our pages</p>
        <div class="text-xs-center mt-5">
          <img :src="require('@/assets/images/404_1.gif')" class="elevation-10" alt="spice money">
        </div>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<style scoped>
.content-title {
  color: #ed1c24;
  font-size: 24px;
  font-weight: normal;
  margin: 0;
  padding: 0;
  text-transform: uppercase;
}
.content-sub-title {
  font-size: 42px;
  line-height: 42px;
  text-transform: uppercase;
  color: #293896;
  margin-bottom: 30px;
}
.pageBg {
  background: #eeefee;
}
img {
  border-radius: 5px;
  width: 100%;
  max-width: 500px;
}
</style>

<script>
import PageNotFound from "./PageNotFound.ts";
export default PageNotFound;
</script>